import { AxiosError } from 'axios'

import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { IErrorDTO } from '@/DTOs/errorDTO'

import {
  postAuthLocalLogin,
  postAuthRefresh,
  postAuthLogout,
  postAuthKeycloak,
} from './services'
import {
  PostAuthLocalLoginParams,
  PostAuthLocalLoginResponse,
  PostAuthRefreshResponse,
  PostAuthLogoutResponse,
  PostAuthKeycloakParams,
  PostAuthKeycloakResponse,
} from './types'

export const useMutationPostAuthLocalLogin = (
  options?: UseMutationOptions<
    PostAuthLocalLoginResponse,
    AxiosError<IErrorDTO>,
    PostAuthLocalLoginParams
  >
) => {
  return useMutation(postAuthLocalLogin, options)
}

export const useMutationPostAuthRefresh = (
  options?: UseMutationOptions<
    PostAuthRefreshResponse,
    AxiosError<IErrorDTO>,
    void
  >
) => {
  return useMutation(postAuthRefresh, options)
}

export const useMutationPostAuthLogout = (
  options?: UseMutationOptions<
    PostAuthLogoutResponse,
    AxiosError<IErrorDTO>,
    void
  >
) => {
  return useMutation(postAuthLogout, options)
}

export const useMutationPostAuthKeycloak = (
  options?: UseMutationOptions<
    PostAuthKeycloakResponse,
    AxiosError<IErrorDTO>,
    PostAuthKeycloakParams
  >
) => {
  return useMutation(postAuthKeycloak, options)
}
